module.exports = {
    appUrl: process.env.appUrl,
    apiBaseUrl: process.env.apiBaseUrl,
    resumePreviewBaseUrl: process.env.resumePreviewBaseUrl,
    socketUrl: process.env.socketUrl
};
